/**
 * DO NOT make direct changes to the file.
 * It is generated by the script 'update-openapi-spec.js'.
 */

export interface paths {
  '/api/customer': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['CustomerController_getCustomerDetail'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/customer/recent-articles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['CustomerController_getRecentArticles'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/customer/open-orders': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['CustomerController_getOpenOrders'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/cart': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['CartController_getCurrentCart'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/cart/articles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete: operations['CartController_emptyCart'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/cart/articles/{pimArticleId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: operations['CartController_putArticleInCart'];
    post?: never;
    delete: operations['CartController_removeArticleFromCart'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/order': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['OrderController_placeOrder'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/order/articles/{pimArticleId}/availability': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['OrderController_getArticleAvailability'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/order/articles/{pimArticleId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['OrderController_getArticleDetailPreCart'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/users': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['UserController_getUsers'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/users/self/language': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: operations['UserController_setUserLanguage'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/users/self': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['UserController_getSelf'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/articles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['ArticleController_getArticles'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/articles-batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['ArticleController_getArticlesBatch'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/articles/filter-references': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['ArticleController_getFilterReferenceData'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/articles/{pimArticleId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['ArticleController_getArticleDetail'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['PingController_getAck'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/pim/status-report': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['PimStateController_getPimDataStatusReport'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/pim/import': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['PimStateController_importPimData'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/erp/health': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['ErpHealthcheckController_getCsbHealthStatus'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/series': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['SeriesController_getSeries'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/request-forms/address-mutation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['FormController_getAddressMutation'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/request-forms/article-not-found': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['FormController_getArticleNotFound'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/request-forms/inquiry-about-article': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['FormController_getInquiryAboutArticle'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/request-forms/anonymous-create-new-user-for-new-customer': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['FormController_getAnonymousCreateNewUserForNewCustomer'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/request-forms/anonymous-create-new-user-for-existing-customer': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['FormController_getAnonymousCreateNewUserForExistingCustomer'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/request-forms/delete-user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['FormController_getCreateDeleteUserAccount'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/request-forms/new-delivery-address': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['FormController_getCreateNewDeliveryAddressForExistingCustomer'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/request-forms/create-new-user-for-existing-customer': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['FormController_getCreateNewUserForExistingCustomer'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/request-forms/send-form': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['FormController_sendMail'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/request-forms/anonymous-send-form': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['FormController_sendAnonymousMail'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/request-forms/order-sample-sheet': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['FormController_getOrderSampleSheet'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/request-forms/service-request': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['FormController_getServiceRequest'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    SingularResponseBuilder: Record<string, never>;
    CustomerAddressResponseDto: {
      name1: string;
      name2: string | null;
      name3: string | null;
      name4: string | null;
      street: string;
      houseNo: string;
      streetAndHouseNo: string;
      country: string;
      zip: string;
      city: string;
      addressString: string;
    };
    CustomerShippingAddressResponseDto: {
      name1: string;
      name2: string | null;
      name3: string | null;
      name4: string | null;
      street: string;
      houseNo: string;
      streetAndHouseNo: string;
      country: string;
      zip: string;
      city: string;
      addressString: string;
      isDefault: boolean;
      addressId: string;
    };
    CustomerDetailResponseDto: {
      name: string;
      invoiceAddress: components['schemas']['CustomerAddressResponseDto'];
      shippingAddresses: components['schemas']['CustomerShippingAddressResponseDto'][];
    };
    ListResponseBuilder: Record<string, never>;
    MinimalSeriesInfoResponseDto: {
      name: string;
      number: string;
      numberColor: string | null;
    };
    ArticleSearchResponseDto: {
      id: string;
      /** @enum {string} */
      availability: ArticleSearchResponseDtoAvailability;
      title: string;
      hexCode: string | null;
      itemDesc2: string;
      itemDesc3: string;
      gloss: string | null;
      effect: string | null;
      surface: string | null;
      bonding: string | null;
      series: components['schemas']['MinimalSeriesInfoResponseDto'];
      weatherResistance: string | null;
      hasRendering: boolean;
    };
    PaginationMeta: {
      pageIndex: number;
      pageCount: number;
      pageSize: number;
      totalCount: number;
    };
    CustomerOpenOrderResponseDto: {
      orderNo: string;
      /** @enum {string} */
      orderStatus: CustomerOpenOrderResponseDtoOrderStatus;
      /** Format: date-time */
      deliveryDate: string | null;
      itemCount: number | null;
      transmitted: boolean;
    };
    LineTotalResponseDto: {
      amount: number;
      formatted: string;
    };
    /** @enum {string} */
    Currency: Currency;
    CurrencyResponseDto: {
      code: components['schemas']['Currency'];
      symbol: string;
    };
    /** @enum {string} */
    Container: Container;
    ItemResponseDto: {
      quantity: number;
      lineTotal: components['schemas']['LineTotalResponseDto'];
      unitTotal: components['schemas']['LineTotalResponseDto'];
      /** @enum {string} */
      type: ItemResponseDtoType;
      container: components['schemas']['Container'];
      erpContainerArticleId: string;
      weightKg: number;
      pricePerKg: number;
      article: components['schemas']['ArticleSearchResponseDto'];
    };
    CartResponseDto: {
      totalItems: number;
      totalUniqueItems: number;
      grandTotal: components['schemas']['LineTotalResponseDto'];
      isEmpty: boolean;
      currency: components['schemas']['CurrencyResponseDto'];
      items: components['schemas']['ItemResponseDto'][];
    };
    CartAddContainerItemRequestDto: {
      erpContainerArticleId: string;
      container: components['schemas']['Container'];
      requestedWeight: number;
    };
    PlaceOrderRequestDto: {
      deliveryAddressId: string;
      orderReference: string | null;
      comment: string | null;
    };
    ContainerItemCombinationResponseDto: {
      container: components['schemas']['Container'];
      item: string;
      maxContainersOnStock: number;
    };
    ArticleAvailabilityInfoResponseDto: {
      isOnlineAvailable: boolean;
      containerItemCombination: components['schemas']['ContainerItemCombinationResponseDto'][];
    };
    ArticleDetailPreCartResponseDto: {
      pimArticleId: string;
      erpContainerArticleId: string;
      weightKg: number;
      neededContainers: number;
      containerWeightKg: number;
      changedWeight: boolean;
      container: components['schemas']['Container'];
      pricePerUnit: number;
      totalPrice: number;
      currency: components['schemas']['Currency'];
    };
    AuthUserResponseDto: {
      name: string;
      email: string;
      isCustomerAdmin: boolean;
      isSelf: boolean;
      isVerified: boolean;
    };
    /** @enum {string} */
    Language: Language;
    LanguageRequestDto: {
      language: components['schemas']['Language'];
    };
    SelfUserResponseDto: {
      name: string;
      email: string;
      isCustomerAdmin: boolean;
      language: Record<string, never> | null;
    };
    ColorRangeResponseDto: {
      id: string;
      name: string;
      hexCode: string | null;
    };
    BasicSeriesInfoResponseDto: {
      name: string;
      number: string;
    };
    ArticleFilterReferencesResponseDto: {
      glosses: string[];
      surfaces: string[];
      categories: string[];
      colorRanges: components['schemas']['ColorRangeResponseDto'][];
      weatherResistances: string[];
      effects: string[];
      series: components['schemas']['BasicSeriesInfoResponseDto'][];
      specialProperties: string[];
      certificates: string[];
    };
    SeriesInfoResponseDto: {
      name: string;
      number: string;
      numberColor: string | null;
    };
    ValueUnitResponseDto: {
      value: number;
      unit: string;
    };
    CuringConditionResponseDto: {
      objectTemperature: components['schemas']['ValueUnitResponseDto'];
      minimumDuration: components['schemas']['ValueUnitResponseDto'];
      maximumDuration: components['schemas']['ValueUnitResponseDto'];
      recommendation: boolean;
    };
    DownloadResponseDto: {
      title: string;
      url: string;
    };
    DownloadSectionResponseDto: {
      name: string;
      downloads: components['schemas']['DownloadResponseDto'][];
    };
    ArticleDetailResponseDto: {
      id: string;
      /** @enum {string} */
      availability: ArticleDetailResponseDtoAvailability;
      title: string;
      hexCode: string | null;
      itemDesc2: string;
      itemDesc3: string;
      icon: string | null;
      gloss: string | null;
      effect: string | null;
      surface: string | null;
      bonding: string | null;
      series: components['schemas']['SeriesInfoResponseDto'];
      shortDescription: string | null;
      description: string | null;
      specialProperties: string[];
      weatherResistance: string | null;
      safetyLabel: string | null;
      imageCuringCondition: string | null;
      curingNote: string | null;
      curingCondition: components['schemas']['CuringConditionResponseDto'][];
      downloads: components['schemas']['DownloadSectionResponseDto'] | null;
      certificateSections: components['schemas']['DownloadSectionResponseDto'][];
      hasRendering: boolean;
    };
    ImportRequestDto: {
      recipient: string;
      minimumSeries: number;
      maximumSeries: number;
      minimumArticles: number;
      maximumArticles: number;
    };
    HealthcheckResponseDto: {
      status: string;
      timestamp: number;
    };
    SeriesResponseDto: {
      seriesName: string;
      seriesNumber: string;
      seriesNumberColor: string | null;
      subtitle: string;
      headerImage: string;
      seriesUrl: string;
    };
    BaseFormFieldResponseDto: {
      /** @enum {string} */
      id: BaseFormFieldResponseDtoId;
      label: string;
      helpText: string | null;
      isDisabled: boolean;
      isRequired: boolean;
      /** @enum {string} */
      fieldType: BaseFormFieldResponseDtoFieldType;
    };
    FormFieldBasicOptionResponseDto: {
      value: string;
      label: string;
    };
    RadioFormFieldResponseDto: {
      /** @enum {string} */
      id: RadioFormFieldResponseDtoId;
      label: string;
      helpText: string | null;
      isDisabled: boolean;
      isRequired: boolean;
      /** @enum {string} */
      fieldType: RadioFormFieldResponseDtoFieldType;
      options: components['schemas']['FormFieldBasicOptionResponseDto'][];
    };
    OptionFormFieldResponseDto: {
      /** @enum {string} */
      id: OptionFormFieldResponseDtoId;
      label: string;
      helpText: string | null;
      isDisabled: boolean;
      isRequired: boolean;
      /** @enum {string} */
      fieldType: OptionFormFieldResponseDtoFieldType;
      options: components['schemas']['FormFieldBasicOptionResponseDto'][];
      placeholder: string;
      value: string | null;
    };
    FormFieldWithValueResponseDto: {
      /** @enum {string} */
      id: FormFieldWithValueResponseDtoId;
      label: string;
      helpText: string | null;
      isDisabled: boolean;
      isRequired: boolean;
      /** @enum {string} */
      fieldType: FormFieldWithValueResponseDtoFieldType;
      value: string;
    };
    FormResponseDto: {
      /** @enum {string} */
      type: FormResponseDtoType;
      fields: (
        | components['schemas']['BaseFormFieldResponseDto']
        | components['schemas']['RadioFormFieldResponseDto']
        | components['schemas']['OptionFormFieldResponseDto']
        | components['schemas']['FormFieldWithValueResponseDto']
      )[];
    };
    FormRequestDto: {
      /** @enum {string} */
      formType: FormRequestDtoFormType;
      /**
       * @example {
       *       "customerId": "string",
       *       "deliveryCompanyName": "string",
       *       "deliveryStreet": "string",
       *       "deliveryPostalCode": "string",
       *       "deliveryCity": "string",
       *       "deliveryCountry": "string",
       *       "deliveryAdditionalInformation": "string",
       *       "deliveryAddress": "string",
       *       "companyName": "string",
       *       "street": "string",
       *       "houseNo": "string",
       *       "postalCode": "string",
       *       "city": "string",
       *       "country": "string",
       *       "additionalInformation": "string",
       *       "uid": "string",
       *       "eori": "string",
       *       "weightKg": "string",
       *       "container": "string",
       *       "email": "string",
       *       "project": "string",
       *       "requesterEmail": "string",
       *       "firstname": "string",
       *       "lastname": "string",
       *       "fullname": "string",
       *       "phone": "string",
       *       "salutation": "string",
       *       "substrate": "string",
       *       "comment": "string",
       *       "subject": "string",
       *       "formOfContact": "string",
       *       "chooseAnOption": "string",
       *       "function": "string",
       *       "deletionEmail": "string",
       *       "quantity": "string",
       *       "serviceType": "string"
       *     }
       */
      fields: {
        [key: string]: string;
      };
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
  CustomerController_getCustomerDetail: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['CustomerDetailResponseDto'];
          };
        };
      };
    };
  };
  CustomerController_getRecentArticles: {
    parameters: {
      query: {
        count: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            items: components['schemas']['ArticleSearchResponseDto'][];
          };
        };
      };
    };
  };
  CustomerController_getOpenOrders: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            items: components['schemas']['CustomerOpenOrderResponseDto'][];
          };
        };
      };
    };
  };
  CartController_getCurrentCart: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['CartResponseDto'];
          };
        };
      };
    };
  };
  CartController_emptyCart: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['CartResponseDto'];
          };
        };
      };
    };
  };
  CartController_putArticleInCart: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        pimArticleId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CartAddContainerItemRequestDto'];
      };
    };
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['CartResponseDto'];
          };
        };
      };
    };
  };
  CartController_removeArticleFromCart: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        pimArticleId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['CartResponseDto'];
          };
        };
      };
    };
  };
  OrderController_placeOrder: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PlaceOrderRequestDto'];
      };
    };
    responses: {
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  OrderController_getArticleAvailability: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        pimArticleId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['ArticleAvailabilityInfoResponseDto'];
          };
        };
      };
    };
  };
  OrderController_getArticleDetailPreCart: {
    parameters: {
      query: {
        weightKg: number;
        container: string;
      };
      header?: never;
      path: {
        pimArticleId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['ArticleDetailPreCartResponseDto'];
          };
        };
      };
    };
  };
  UserController_getUsers: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            items: components['schemas']['AuthUserResponseDto'][];
          };
        };
      };
    };
  };
  UserController_setUserLanguage: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LanguageRequestDto'];
      };
    };
    responses: {
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  UserController_getSelf: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['SelfUserResponseDto'];
          };
        };
      };
    };
  };
  ArticleController_getArticles: {
    parameters: {
      query: {
        query: string;
        limit: number;
        offset: number;
        glosses: string[];
        surfaces: string[];
        categories: string[];
        colorRanges: string[];
        weatherResistances: string[];
        effects: string[];
        seriesNumbers: string[];
        substrates: string[];
        specialProperties: string[];
        certificates: string[];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            items: components['schemas']['ArticleSearchResponseDto'][];
            meta: {
              pagination: components['schemas']['PaginationMeta'];
            };
          };
        };
      };
    };
  };
  ArticleController_getArticlesBatch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            items: components['schemas']['ArticleSearchResponseDto'][];
          };
        };
      };
    };
  };
  ArticleController_getFilterReferenceData: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['ArticleFilterReferencesResponseDto'];
          };
        };
      };
    };
  };
  ArticleController_getArticleDetail: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        pimArticleId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['ArticleDetailResponseDto'];
          };
        };
      };
    };
  };
  PingController_getAck: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  PimStateController_getPimDataStatusReport: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  PimStateController_importPimData: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImportRequestDto'];
      };
    };
    responses: {
      202: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  ErpHealthcheckController_getCsbHealthStatus: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['HealthcheckResponseDto'];
          };
        };
      };
    };
  };
  SeriesController_getSeries: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            items: components['schemas']['SeriesResponseDto'][];
          };
        };
      };
    };
  };
  FormController_getAddressMutation: {
    parameters: {
      query: {
        companyName: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['FormResponseDto'];
          };
        };
      };
    };
  };
  FormController_getArticleNotFound: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['FormResponseDto'];
          };
        };
      };
    };
  };
  FormController_getInquiryAboutArticle: {
    parameters: {
      query: {
        articleId: string;
        weightKg: number;
        container: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['FormResponseDto'];
          };
        };
      };
    };
  };
  FormController_getAnonymousCreateNewUserForNewCustomer: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['FormResponseDto'];
          };
        };
      };
    };
  };
  FormController_getAnonymousCreateNewUserForExistingCustomer: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['FormResponseDto'];
          };
        };
      };
    };
  };
  FormController_getCreateDeleteUserAccount: {
    parameters: {
      query: {
        emailToDelete: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['FormResponseDto'];
          };
        };
      };
    };
  };
  FormController_getCreateNewDeliveryAddressForExistingCustomer: {
    parameters: {
      query: {
        companyName: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['FormResponseDto'];
          };
        };
      };
    };
  };
  FormController_getCreateNewUserForExistingCustomer: {
    parameters: {
      query: {
        companyName: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['FormResponseDto'];
          };
        };
      };
    };
  };
  FormController_sendMail: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FormRequestDto'];
      };
    };
    responses: {
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  FormController_sendAnonymousMail: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FormRequestDto'];
      };
    };
    responses: {
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  FormController_getOrderSampleSheet: {
    parameters: {
      query: {
        articleId: string;
        storedAddressId: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['FormResponseDto'];
          };
        };
      };
    };
  };
  FormController_getServiceRequest: {
    parameters: {
      query: {
        articleId: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            data: components['schemas']['FormResponseDto'];
          };
        };
      };
    };
  };
}
export enum ArticleSearchResponseDtoAvailability {
  available = 'available',
  uponRequest = 'uponRequest',
}
export enum CustomerOpenOrderResponseDtoOrderStatus {
  RECEIVED = 'RECEIVED',
  PROCESSED = 'PROCESSED',
  DELIVERED = 'DELIVERED',
  UNKNOWN = 'UNKNOWN',
}
export enum Currency {
  CHF = 'CHF',
  EUR = 'EUR',
  USD = 'USD',
}
export enum Container {
  P02 = 'P02',
  P05 = 'P05',
  K10 = 'K10',
  K15 = 'K15',
  K20 = 'K20',
}
export enum ItemResponseDtoType {
  SKU = 'SKU',
  TAX = 'TAX',
  SHIPPING = 'SHIPPING',
}
export enum Language {
  en = 'en',
  de = 'de',
  fr = 'fr',
  pl = 'pl',
}
export enum ArticleDetailResponseDtoAvailability {
  available = 'available',
  uponRequest = 'uponRequest',
}
export enum BaseFormFieldResponseDtoId {
  customerId = 'customerId',
  deliveryCompanyName = 'deliveryCompanyName',
  deliveryStreet = 'deliveryStreet',
  deliveryPostalCode = 'deliveryPostalCode',
  deliveryCity = 'deliveryCity',
  deliveryCountry = 'deliveryCountry',
  deliveryAdditionalInformation = 'deliveryAdditionalInformation',
  deliveryAddress = 'deliveryAddress',
  companyName = 'companyName',
  street = 'street',
  houseNo = 'houseNo',
  postalCode = 'postalCode',
  city = 'city',
  country = 'country',
  additionalInformation = 'additionalInformation',
  uid = 'uid',
  eori = 'eori',
  weightKg = 'weightKg',
  container = 'container',
  email = 'email',
  project = 'project',
  requesterEmail = 'requesterEmail',
  firstname = 'firstname',
  lastname = 'lastname',
  fullname = 'fullname',
  phone = 'phone',
  salutation = 'salutation',
  substrate = 'substrate',
  comment = 'comment',
  subject = 'subject',
  formOfContact = 'formOfContact',
  chooseAnOption = 'chooseAnOption',
  function = 'function',
  deletionEmail = 'deletionEmail',
  quantity = 'quantity',
  serviceType = 'serviceType',
}
export enum BaseFormFieldResponseDtoFieldType {
  email = 'email',
  number = 'number',
  text = 'text',
  textarea = 'textarea',
  option = 'option',
  radio = 'radio',
}
export enum RadioFormFieldResponseDtoId {
  customerId = 'customerId',
  deliveryCompanyName = 'deliveryCompanyName',
  deliveryStreet = 'deliveryStreet',
  deliveryPostalCode = 'deliveryPostalCode',
  deliveryCity = 'deliveryCity',
  deliveryCountry = 'deliveryCountry',
  deliveryAdditionalInformation = 'deliveryAdditionalInformation',
  deliveryAddress = 'deliveryAddress',
  companyName = 'companyName',
  street = 'street',
  houseNo = 'houseNo',
  postalCode = 'postalCode',
  city = 'city',
  country = 'country',
  additionalInformation = 'additionalInformation',
  uid = 'uid',
  eori = 'eori',
  weightKg = 'weightKg',
  container = 'container',
  email = 'email',
  project = 'project',
  requesterEmail = 'requesterEmail',
  firstname = 'firstname',
  lastname = 'lastname',
  fullname = 'fullname',
  phone = 'phone',
  salutation = 'salutation',
  substrate = 'substrate',
  comment = 'comment',
  subject = 'subject',
  formOfContact = 'formOfContact',
  chooseAnOption = 'chooseAnOption',
  function = 'function',
  deletionEmail = 'deletionEmail',
  quantity = 'quantity',
  serviceType = 'serviceType',
}
export enum RadioFormFieldResponseDtoFieldType {
  email = 'email',
  number = 'number',
  text = 'text',
  textarea = 'textarea',
  option = 'option',
  radio = 'radio',
}
export enum OptionFormFieldResponseDtoId {
  customerId = 'customerId',
  deliveryCompanyName = 'deliveryCompanyName',
  deliveryStreet = 'deliveryStreet',
  deliveryPostalCode = 'deliveryPostalCode',
  deliveryCity = 'deliveryCity',
  deliveryCountry = 'deliveryCountry',
  deliveryAdditionalInformation = 'deliveryAdditionalInformation',
  deliveryAddress = 'deliveryAddress',
  companyName = 'companyName',
  street = 'street',
  houseNo = 'houseNo',
  postalCode = 'postalCode',
  city = 'city',
  country = 'country',
  additionalInformation = 'additionalInformation',
  uid = 'uid',
  eori = 'eori',
  weightKg = 'weightKg',
  container = 'container',
  email = 'email',
  project = 'project',
  requesterEmail = 'requesterEmail',
  firstname = 'firstname',
  lastname = 'lastname',
  fullname = 'fullname',
  phone = 'phone',
  salutation = 'salutation',
  substrate = 'substrate',
  comment = 'comment',
  subject = 'subject',
  formOfContact = 'formOfContact',
  chooseAnOption = 'chooseAnOption',
  function = 'function',
  deletionEmail = 'deletionEmail',
  quantity = 'quantity',
  serviceType = 'serviceType',
}
export enum OptionFormFieldResponseDtoFieldType {
  email = 'email',
  number = 'number',
  text = 'text',
  textarea = 'textarea',
  option = 'option',
  radio = 'radio',
}
export enum FormFieldWithValueResponseDtoId {
  customerId = 'customerId',
  deliveryCompanyName = 'deliveryCompanyName',
  deliveryStreet = 'deliveryStreet',
  deliveryPostalCode = 'deliveryPostalCode',
  deliveryCity = 'deliveryCity',
  deliveryCountry = 'deliveryCountry',
  deliveryAdditionalInformation = 'deliveryAdditionalInformation',
  deliveryAddress = 'deliveryAddress',
  companyName = 'companyName',
  street = 'street',
  houseNo = 'houseNo',
  postalCode = 'postalCode',
  city = 'city',
  country = 'country',
  additionalInformation = 'additionalInformation',
  uid = 'uid',
  eori = 'eori',
  weightKg = 'weightKg',
  container = 'container',
  email = 'email',
  project = 'project',
  requesterEmail = 'requesterEmail',
  firstname = 'firstname',
  lastname = 'lastname',
  fullname = 'fullname',
  phone = 'phone',
  salutation = 'salutation',
  substrate = 'substrate',
  comment = 'comment',
  subject = 'subject',
  formOfContact = 'formOfContact',
  chooseAnOption = 'chooseAnOption',
  function = 'function',
  deletionEmail = 'deletionEmail',
  quantity = 'quantity',
  serviceType = 'serviceType',
}
export enum FormFieldWithValueResponseDtoFieldType {
  email = 'email',
  number = 'number',
  text = 'text',
  textarea = 'textarea',
  option = 'option',
  radio = 'radio',
}
export enum FormResponseDtoType {
  createNewUserForExistingCustomer = 'createNewUserForExistingCustomer',
  createNewUserForNewCustomer = 'createNewUserForNewCustomer',
  inquiryAboutArticle = 'inquiryAboutArticle',
  articleNotFound = 'articleNotFound',
  addressMutation = 'addressMutation',
  newDeliveryAddress = 'newDeliveryAddress',
  deleteUser = 'deleteUser',
  orderSampleSheet = 'orderSampleSheet',
  serviceRequest = 'serviceRequest',
}
export enum FormRequestDtoFormType {
  createNewUserForExistingCustomer = 'createNewUserForExistingCustomer',
  createNewUserForNewCustomer = 'createNewUserForNewCustomer',
  inquiryAboutArticle = 'inquiryAboutArticle',
  articleNotFound = 'articleNotFound',
  addressMutation = 'addressMutation',
  newDeliveryAddress = 'newDeliveryAddress',
  deleteUser = 'deleteUser',
  orderSampleSheet = 'orderSampleSheet',
  serviceRequest = 'serviceRequest',
}
